/**
 * 支付相关API
 */
import http from './http'

export default class PayApi {
    static getList() {
        return http.httpGet('pay/list');
    }

    static getItem(key) {
        return http.httpGet('pay', {key});
    }

    static getPayInfoByNo(orderNo) {
        return http.httpGet('pay/getPayInfoByNo', {orderNo});
    }

    static addOrderForm(params) {
        return http.httpPost('pay/addOrderForm', params);
    }
    static payVip(params) {
        return http.httpPost('pay/vip', params);
    }
    static isCompleteVipPay(params) {
        return http.httpPost('pay/isCompleteVipPay', params);
    }
    static addOrderInvoice(params) {
        return http.httpPost('pay/addOrderInvoice', params);
    }
    //获取最后一个订单
    static getOrderOnce(params) {
        return http.httpPost('pay/getOrderOnce',params);
    }
}



// WEBPACK FOOTER //
// ./app/api/pay.api.js